import React, { useEffect } from "react";
import { Route } from "react-router-dom";
import { getUserDetailsFromCookie } from "../../utils/getCookies";

const PrivateRoute = ({ component: Component, auth, user, ...rest }) => {
  useEffect(() => {
    const userFound = getUserDetailsFromCookie();
    if (!userFound && !window.location.pathname.includes("feed/post")) {
      window.location.href = window.location.origin + "/login";
    }
  }, []);

  return (
    <Route
      {...rest}
      render={(props) => {
        return <Component {...props} />;
      }}
    />
  );
};

export default PrivateRoute;

